import Controller from '@ember/controller';

export default class AuthenticatedTasConfirmationController extends Controller {
  queryParams = ['applicationId', 'tasType', 'evidence'];
}
